import { useFormContext } from 'react-hook-form';
import { Banner, Title, Typography } from '@optimus-web/core';
import { LocalizedText, lt, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { RoutingRuleFormValues } from '../../../../../schemas';
import { useServicesSuspenseQuery } from '../queries';
import { ItemsServiceList } from './ItemsServiceList';

export const ItemsFields = () => {
    const {
        data: { bookableServices, additionalServices },
    } = useServicesSuspenseQuery();
    const {
        formState: { errors },
    } = useFormContext<RoutingRuleFormValues>();

    const newRoutingRulesPOSEnabled = useFeatureFlag(FeatureFlag.newRoutingRulesPOSEnabled);

    return (
        <>
            {errors?.itemsAndConditions?.services?.textKey ? (
                <Banner
                    variant="error"
                    /* @ts-expect-error */
                    primaryText={<LocalizedText textKey={errors.itemsAndConditions.services.textKey} />}
                />
            ) : null}
            {newRoutingRulesPOSEnabled && (
                <Title level={3}>
                    <LocalizedText textKey={TextKey.BookableServicePlural} />
                    {UnicodeEntity.Asterisk}
                </Title>
            )}
            <ItemsServiceList services={bookableServices} />
            {newRoutingRulesPOSEnabled && additionalServices.length > 0 && (
                <>
                    {errors?.itemsAndConditions?.additionalServices?.textKey ? (
                        <Banner
                            variant="error"
                            primaryText={
                                /* @ts-expect-error */
                                <LocalizedText textKey={errors.itemsAndConditions.additionalServices.textKey} />
                            }
                        />
                    ) : null}
                    <Title level={3}>
                        <LocalizedText textKey={TextKey.AdditionalServicePlural} />
                    </Title>
                    <Typography variant="secondary" textStyle="bodyMedium" as="div">
                        {lt(TextKey.RoutingRulesFormFieldDescriptionAdditionalServices)}
                    </Typography>
                    <ItemsServiceList services={additionalServices} />
                </>
            )}
        </>
    );
};
